export default __webpack_public_path__ + "static/media/document-back.f8550189.svg";